import React, { useState } from 'react';
import { Box } from '@mui/material';
import QueryForm from '../components/Query/QueryForm';
import QueryResults from '../components/Query/QueryResults';

const QueryPage = () => {
  const [results, setResults] = useState(null);
  const [showReasoning, setShowReasoning] = useState(false);
  
  const handleResultsReceived = (data, useReasoning) => {
    setResults(data);
    setShowReasoning(useReasoning);
  };
  
  return (
    <Box>
      <QueryForm onResultsReceived={handleResultsReceived} />
      <QueryResults results={results} showReasoning={showReasoning} />
    </Box>
  );
};

export default QueryPage;
